import React, { useState, useEffect } from 'react';
import './LandingNewsContent.css';

const LandingNewsContent = () => {
  const [sheetUrl, setSheetUrl] = useState(
    'https://docs.google.com/spreadsheets/d/17gMAOb-Su9yaXkmf1A5T23HYtktesWFb6cFQ50p0WR8/edit?usp=sharing',
  );
  const [newsItems, setNewsItems] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(
          'https://opensheet.elk.sh/17gMAOb-Su9yaXkmf1A5T23HYtktesWFb6cFQ50p0WR8/1',
        );
        const data = await response.json();
        if (data && data.length > 0) {
          const formattedNews = data.map((item, index) => ({
            id: index + 1,
            title: item.title,
            image: item.image_url,
            tags: ['News'],
            date: item.publish_date,
            url: item.article_url,
            summary: item.summary,
          }));
          setNewsItems(formattedNews);
          if (data[0] && data[0].article_url) {
            setSheetUrl(data[0].article_url);
          }
        }
      } catch (error) {
        console.error('Error fetching news from google sheet:', error);
      }
    };
    fetchNews();
  }, []);

  return (
    <section className='news-container'>
      <h2 className='news-title'>ข่าวสารจาก มียา.com</h2>

      <div className='news-grid'>
        {newsItems.map((item) => (
          <a
            key={item.id}
            href={item.url || sheetUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='news-card'
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className='news-image-wrapper'>
              <img src={item.image} alt={item.title} className='news-image' />
            </div>
            <div className='news-content'>
              <div className='news-tags'>
                {item.tags.map((tag, index) => (
                  <span key={index} className='news-tag'>
                    {tag}
                  </span>
                ))}
              </div>
              <h3 className='news-card-title'>{item.title}</h3>
              <div className='news-date'>{item.date}</div>
            </div>
          </a>
        ))}
      </div>

      <div className='news-actions'>
        <a
          href='https://meya-th.blogspot.com/'
          target='_blank'
          rel='noopener noreferrer'
          className='news-view-all-btn'
          style={{
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ดูทั้งหมด
        </a>
      </div>
    </section>
  );
};

export default LandingNewsContent;
